import React, { useEffect, useState } from 'react';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import PartidosTorneoSeleccion from './PartidosTorneoSeleccion.js';
import useGetURLStatus from '../../hooks/useGetURLStatus.js';
import styles from './Selecciones.module.css';

const ParticipacionSeleccionTorneo = (props) => {
  const pais = props.pais;
  const idPais = props.pais && props.pais.id;
  const categoria = props.categoria;
  const torneo = props.torneo;
  const titulo = props.titulo;
  const [participante, setParticipante] = useState(null);
  const { isCargando, status, erroresGet, fetchData, resetErroresGet } = useGetURLStatus();

  useEffect(() => {
    resetErroresGet();
  }, [resetErroresGet]);

  const idTorneo = props.torneo && props.torneo.id;

  useEffect(() => {
    setParticipante(null);
    if (idPais !== null && idTorneo !== null) {
      fetchData('selecciones_pais/' + idPais + '/torneos/' + idTorneo, setParticipante);
    }
  }, [fetchData, idPais, idTorneo]);

  return (
    <div className={`${styles.cuadroPartidos}`}>
      {!isCargando && status !== 204 && (
        <React.Fragment>
          {titulo && <span className={`${styles.tituloCuadroPartidos}`}>{titulo}</span>}
          {participante && (
            <React.Fragment>
              <PartidosTorneoSeleccion pais={pais} categoria={categoria} torneo={torneo} />
              <table className={`${styles.tablaDatos}`}>
                <tbody>
                  {participante.observaciones && (
                    <tr>
                      <td className={`${styles.titulo}`}>Observaciones</td>
                      <td className={`${styles.valor}`}>
                        {participante && participante.observaciones}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
      <MensajeCargando estilo={`${styles.cargandoDatos}`} isCargando={isCargando} />
      <MensajeError estilo={`${styles.error}`} errores={status !== 204 && erroresGet} />
    </div>
  );
};

export default ParticipacionSeleccionTorneo;
